import Component from '../abstracts/Component';
import ScrollMagic from 'scrollmagic';
import 'animation.gsap';
// import 'debug.addIndicators';

export default class ProductHeadComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-product-head',
      productHead: '.product-head .picture',
      cursor: '.image-cursor'
    }
  }

  constructor() {
    super()
    this.controller = new ScrollMagic.Controller();
    this.scene;
  }

  getLastImageHeight() {

    const imgHeight = $('.product-images .media-container:last-of-type').outerHeight()
    const discoverLook = $('.discover-look');

    discoverLook.css({
      'top': 'calc(100% - ' + imgHeight + 'px)',
      'display': 'block'
    })


  }

  setPositions(direction) {
    const customOffset = this.$matchMedia(null, 'lg') ? '80' : '70';
    let setDuration;
    if ($('.discover-look').length > 0) {
      setDuration = document.querySelector('.product-images .media-container:last-of-type').offsetTop - document.querySelector('.wrap-info').offsetHeight - customOffset
    } else {
      setDuration = document.querySelector('.product-images .media-container:last-of-type').offsetTop + document.querySelector('.product-images .media-container:last-of-type').offsetHeight - document.querySelector('.wrap-info').offsetHeight - customOffset
    }

    const swatches = document.querySelector('.swatches').offsetTop

    if (direction != 'FORWARD' && this.scene) {
      $('.wrapper-product-head').addClass('translateY');

    }else{
      $('.wrapper-product-head').removeClass('translateY');

    }

    if(!this.scene){
      this.bindScroll(customOffset, setDuration, swatches)
    }

  }

  bindScroll(customOffset, setDuration, swatches) {

    this.scene = new ScrollMagic.Scene({
        triggerElement: ".carousel.js-product-zoom",
        duration: setDuration - customOffset,
        triggerHook: 0,
        offset: swatches - customOffset
      })
      .setPin(".wrap-info")
      .addTo(this.controller);

      this.scene.on("leave", function (event) {
        $('.wrapper-product-head').removeClass('translateY');
      });
  }

  render() {

    let _this = this;

    $(window).on('load resize scroll', () => {
      if ($('.discover-look').length > 0) {
        if (this.$matchMedia(null, 'sm')) {
          this.getLastImageHeight();
        } else {
          $('.discover-look').css('top', 'auto')
        }
      }
    })

    if (this.$matchMedia(null, 'sm')) {
      this.setPositions()
    }

    $(window).on('resize ', () => {
      if (this.scene) {
        this.scene = this.scene.destroy(true);
      }

      if (this.$matchMedia(null, 'sm')) {
        this.setPositions()
      }
    })

    if (this.$matchMedia(null, 'sm')) {
      this.$on('click', () => {
        this.scene = this.scene.destroy(true);
        this.setPositions()
      }, $('#product-accordion h4.level-one'), $('#product-description .nav-item'));

      var $cursor = $(`${this.SELECTORS.productHead} ${this.SELECTORS.cursor}`);

      function moveCursor(e) {
        let hovered = false;
        // let isZoom = false;
        $(`${_this.SELECTORS.productHead} img, .js-product-zoom-md img`).each((index, element)=>{
          if($(element).is(":hover")){
            hovered = true;
            // console.log($(element).closest('.js-product-zoom-md'))
            if($(element).closest('.js-product-zoom-md').length){
              $cursor.addClass('close-image');
            }else{
              $cursor.removeClass('close-image');
            }
            return false;
          }
        });
        if(hovered){
          $cursor.addClass('show');
        }else{
          $cursor.removeClass('show');
        }
        TweenLite.to($cursor, 0.1, {
          css: {
            x: e.clientX,
            y: e.clientY
          }
        });
      }

      $(window).on('mousemove', moveCursor);

    }

    $(window).on('scroll', () => {
      if (this.scene) {
        let _this = this;
        this.scene.on("progress", function (event) {
          let dir = window.dir
          if (dir != event.scrollDirection) {
            window.dir = event.scrollDirection;

            _this.setPositions(event.scrollDirection)

          }

        })
      }
    })

  }

}
